import React from 'react';
import "./BackgroundTable.css";

function BackgroundTable({children} ) {
    return (
        <div className="background-table">
            {children}
        </div>
    );
}

export default BackgroundTable;